export class PopoverContentStyle {
  size = 'uk-h5';
  font = 'tb-font-primary';
  marginTop = 'uk-margin-top';

  static normalize(styles: Partial<PopoverContentStyle>): PopoverContentStyle {
    const pureStyles = new PopoverContentStyle();

    pureStyles.size = styles.size ?? pureStyles.size;
    pureStyles.font = styles.font ?? pureStyles.font;
    pureStyles.marginTop = styles.marginTop ?? pureStyles.marginTop;

    return pureStyles;
  }
}
